import { z } from 'zod';
import { IsoTimestamp } from './common';

export const WaitlistEntry = z.object({
  email: z.string().email(),
  signedUpAt: IsoTimestamp,
  source: z.string().optional(),
  userAgent: z.string().optional(),
});

export type WaitlistEntry = z.infer<typeof WaitlistEntry>;

export const CreateWaitlistSignupRequest = z.object({
  email: z.string().email().max(254),
  source: z.string().max(64).optional(),
  // #488 — Turnstile gate temporarily disabled after prod outage
  // (widget error 400020 despite valid hostname allowlist). Marketing
  // site no longer sends the token; API fail-opens when it's absent.
  // Kept optional (not removed) so the plumbing stays intact for a
  // future re-enable once we understand the root cause.
  turnstileToken: z.string().min(1).max(2048).optional(),
});

export const CreateWaitlistSignupResponse = z.object({
  ok: z.literal(true),
  alreadySignedUp: z.boolean(),
});
